import sx from 'utils/createSx';

export default sx({
  mainWrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  mainPart: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#cccccc',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
